<template>
  <div id="app">
    <home-page></home-page>
  </div>
</template>

<script>
import homePage from './components/homePage.vue'

export default {
  name: 'App',
  components: {
    homePage
  }
}
</script>

<style>
  @import './assets/reset.css';
</style>
